export default __webpack_public_path__ + "static/media/valid.a83c17bc.svg";